module.exports = __webpack_public_path__ + "static/media/Technikraum_clickarea_02_on.b6559c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/machine-room/Technikraum_clickarea_02_on.png
// module id = 519
// module chunks = 0